import styled from "@emotion/styled";
import { color } from "styles/color";

export const TableOutter = styled.div`
  @media print {
    color-adjust: exact;
  }
  .box {
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: 1rem;
    @media (min-width: 768px) {
      flex-flow: row nowrap;
      align-items: center;
      div:first-of-type {
        margin-left: auto;
      }
    }
    .scanBtn {
      order: 2;
      display: flex;
      flex-flow: column nowrap;
      margin-top: 1rem;
      @media (min-width: 414px) {
        flex-flow: row nowrap;
        align-items: center;
      }
      @media (min-width: 768px) {
        order: 1;
        margin-top: 0rem;
      }
      .ant-checkbox-inner {
        border-color: ${color.markedSecondary};
      }
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${color.markedSecondary};
      }
    }
    .btn {
      background-color: ${color.markedSecondary};
      color: white;
      border: none;
      border-radius: 0.2rem;
      padding: 0.2rem 0.5rem;
      display: inline-block;
      max-width: 40%;
      @media (min-width: 768px) {
        max-width: 100%;
        margin-top: 0;
      }
    }
    .ant-checkbox-wrapper {
      margin-top: 1rem;
      @media (min-width: 414px) {
        margin-left: 1rem;
        margin-top: 0;
      }
    }
  }
  .ant-tabs-tab {
    background-color: ${color.secondary};
    .ant-tabs-tab-btn {
      color: ${color.default};
    }
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    background-color: ${color.markedDefault};
    .ant-tabs-tab-btn {
      color: ${color.primaryBlue};
    }
  }
  .settingBtn {
    cursor: pointer;
    color: white;
    background-color: ${color.markedSecondary};
    text-align: center;
    border-radius: 0.2rem;
    padding: 0.2rem 0;
    max-width: 50px;
  }
  .clearBtn {
    background-color: ${color.markedDefault};
    padding: 0.2rem 0;
    width: 100%;
    max-width: 50px;
    text-align: center;
    border-radius: 0.2rem;
    cursor: pointer;
    outline: none;
    border: none;
    &:disabled {
      color: ${color.default};
      background-color: ${color.borderGray};
    }
  }
  .delSingle {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0);
    border: none;
    transition: all 0.3s ease-out;
    color: ${color.default};
    &:hover {
      color: ${color.warnning};
    }
    &:focus-visible {
      outline: none;
    }
  }
  .ant-table-container {
    border: 0;
    border-left: 1px solid #f0f0f0;
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    border-bottom: none;
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
      border-right: 0 !important;
    }
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.primaryBlue};
    border-right: 1px solid ${color.primaryBlue} !important;
    &:first-of-type {
      border-left: 1px solid ${color.primaryBlue};
    }
  }
  .ant-table-container {
    border-bottom: 1px black solid;
  }
  .ant-table-row {
    &:nth-of-type(odd) {
      //3n+4
      background-color: ${color.secondary};
    }
    &:nth-of-type(even) {
      //3n+4
      background-color: white;
    }
  }
  .ant-table-sticky-scroll-bar {
    position: absolute;
    bottom: 30%;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
  .deleteDateRange {
    display: flex;
    margin-bottom: 1rem;
    .selector {
      min-width: 200px;
    }
    .delRange {
      background-color: white;
      color: ${color.markedSecondary};
      border: 1px ${color.markedSecondary} solid;
      border-radius: 0.2rem;
      padding: 0.2rem 0.5rem;
      margin-left: 1rem;
      transition: all 0.3s ease-out;
      &:hover {
        color: white;
        background-color: ${color.markedSecondary};
      }
      &:disabled {
        color: ${color.borderGray};
        border: 1px ${color.borderGray} solid;
        &:hover {
          background-color: ${color.borderGray};
        }
      }
    }
  }
`;

export const StyledDiv = styled.div`
  color: ${(props: { actived: boolean }) =>
    props.actived ? `${color.markedDefault}` : `${color.markedSecondary}`};
`;
